import styled, { css, DefaultTheme } from 'styled-components';

const VersionCardStyled = styled.li`
  ${({ isActive, theme }: { isActive?: boolean; theme: DefaultTheme }) => {
    return css`
      border-width: 0.125em 0.125em 0.125em 0.375em;
      border-style: solid;
      border-color: var(--color-neutral-30);
      border-radius: 0.188em;
      background-color: var(--color-white);
      padding: 1em;
      position: relative;
      list-style: none;
      &:hover,
      &:focus-within {
        border-color: var(--color-teal);
      }
      &:focus,
      .version-card__title:focus {
        border: none !important;
        box-shadow: none !important;
        outline: none;
      }
      .version-card__header,
      .version-card__footer {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .version-card__header {
        flex-direction: column;
        align-items: flex-start;
        @media ${theme.mq.min.mobile} {
          flex-direction: row;
        }
      }
      .version-card__title {
        font-weight: 700;
        font-size: 1em;
        line-height: 1.5em;
        margin: 0 0 0.5em 0;
        color: var(--color-neutral-70);
        text-decoration: none;
        display: flex;
        align-items: center;
        @media ${theme.mq.min.mobile} {
          margin: 0;
        }
      }
      .version-card__title__wrap {
        flex-wrap: wrap;
        > .version-card__check-icon--wrapper {
          margin-bottom: 0.5em;
        }
      }
      .version-card__title:after {
        content: '';
        position: absolute;
        inset: 0;
      }
      .version-card__text {
        font-weight: 400;
        font-size: 0.875em;
        line-height: 1.5em;
        margin: 1em 0;
        color: var(--color-neutral-70);
      }
      .version-card__footer {
        font-weight: 400;
        font-size: 0.875em;
        line-height: 1.5em;
        color: var(--color-neutral-70);
        display: none;
        flex-direction: row;
        align-items: flex-start;
        @media ${theme.mq.min.mobile} {
          display: flex;
          align-items: center;
        }
      }
      .version-card__info {
        display: flex;
        align-items: center;
        &:not(:last-child) {
          margin-bottom: 0.5em;
        }
        @media ${theme.mq.min.mobile} {
          &:not(:last-child) {
            margin-bottom: 0;
          }
          &:last-child {
            padding-left: 0.25em;
          }
        }
      }
      .version-card__info--link {
        z-index: 6;
        position: relative;
        color: var(--color-blue);
        &:hover {
          text-decoration: none;
        }
      }
      .version-card__avatar,
      .version-card__icon {
        margin-right: 0.5em;
      }
      ${isActive &&
      css`
        border-color: var(--color-teal);
        .version-card__check-icon--wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          width: 1em;
          height: 1em;
          background: var(--color-teal);
          margin-right: 0.5em;
        }
      `}
    `;
  }}
`;

export default VersionCardStyled;
